import { render, staticRenderFns } from "./SpecialCourseTeacherRollStat.vue?vue&type=template&id=0bc0bf9c&scoped=true"
import script from "./SpecialCourseTeacherRollStat.vue?vue&type=script&lang=js"
export * from "./SpecialCourseTeacherRollStat.vue?vue&type=script&lang=js"
import style0 from "./SpecialCourseTeacherRollStat.vue?vue&type=style&index=0&id=0bc0bf9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc0bf9c",
  null
  
)

export default component.exports